module.exports = __webpack_public_path__ + "img/logo-ape-white.svg";